import type { TypedWrappedFieldProps } from "redux-form";

import type { TextFieldProps } from "@braintrust/braintrust-ui-components";
import { IconButton, Tooltip } from "@braintrust/braintrust-ui-components";
import { InfoIcon } from "@braintrust/braintrust-ui-components/Icons";
import { TextField } from "@js/forms/fields";

import styles from "./style.module.scss";

type FieldProps = TypedWrappedFieldProps<string> & TextFieldProps;

type InvoiceNumberFieldProps = FieldProps & {
  isEdit?: boolean;
};

export const InvoiceNumberField = ({
  isEdit,
  input,
  ...props
}: InvoiceNumberFieldProps) => {
  if (isEdit) {
    return (
      <div className={styles.invoiceFieldNumber} title="Invoice Number">
        {input.value}
      </div>
    );
  }

  return (
    <>
      <TextField
        label="Invoice Number"
        variant="standard"
        input={input}
        sx={{ input: { pr: "24px !important" } }}
        {...props}
      />
      <Tooltip
        className={styles.invoiceFieldTooltip}
        title="You can change your invoice number to match your records."
      >
        <IconButton variant="transparent" aria-label="about invoice number">
          <InfoIcon />
        </IconButton>
      </Tooltip>
    </>
  );
};
